import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [formData, setFormData] = useState({
        username: 'king_superadmin@gmail.com',
        password: '12345'
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const { login, isAuthenticated, loading: authLoading } = useAuth();
    const navigate = useNavigate();

    // Redirect if already authenticated
    useEffect(() => {
        if (isAuthenticated && !authLoading) {
            navigate('/dashboard', { replace: true });
        }
    }, [isAuthenticated, authLoading, navigate]);

    // Show loading while checking auth
    if (authLoading) {
        return (
            <Container fluid className="luxury-login-bg min-vh-100 d-flex align-items-center justify-content-center">
                <Spinner animation="border" variant="light" />
            </Container>
        );
    }

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!formData.username || !formData.password) {
            setError('Please fill in all fields');
            setLoading(false);
            return;
        }

        try {
            const result = await login(formData.username, formData.password);

            if (result.success) {
                navigate('/dashboard', { replace: true });
            } else {
                setError(result.error || 'Login failed. Please try again.');
            }
        } catch (err) {
            setError('An unexpected error occurred. Please try again.');
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container fluid className="luxury-login-bg min-vh-100 d-flex align-items-center justify-content-center py-4 position-relative overflow-hidden">
            {/* Luxury jewelry floating elements */}
            {/*} <div className="luxury-shape luxury-necklace" style={{ top: '10%', left: '15%' }}>💎</div>
            <div className="luxury-shape luxury-earring" style={{ top: '20%', right: '12%' }}>👑</div>
            <div className="luxury-shape luxury-ring" style={{ bottom: '15%', left: '25%' }}>💍</div>
            <div className="luxury-shape luxury-bracelet" style={{ top: '35%', left: '8%' }}>📿</div>
            <div className="luxury-shape luxury-crown" style={{ bottom: '20%', right: '15%' }}>👸</div>
            <div className="luxury-shape luxury-tiara" style={{ top: '5%', right: '8%' }}>👑</div>
            <div className="luxury-shape luxury-diamond" style={{ bottom: '35%', right: '25%' }}>💎</div>
            <div className="luxury-shape luxury-pearl" style={{ top: '65%', right: '10%' }}>🟣</div>
            <div className="luxury-shape luxury-gem" style={{ top: '45%', left: '85%' }}>🔴</div>
            <div className="luxury-shape luxury-brooch" style={{ bottom: '5%', left: '10%' }}>🧷</div>
            <div className="luxury-shape luxury-pendant" style={{ top: '75%', left: '15%' }}>📿</div>
            <div className="luxury-shape luxury-necklace" style={{ top: '25%', left: '40%' }}>🔗</div>
            <div className="luxury-shape luxury-ring" style={{ bottom: '45%', left: '60%' }}>💍</div> */}

            {/* Additional luxury elements */}
            {/* <div className="luxury-shape luxury-earring" style={{ top: '55%', left: '20%' }}>💫</div>
            <div className="luxury-shape luxury-bracelet" style={{ top: '15%', left: '75%' }}>✨</div> */}

            {/* Luxury pattern lines */}
            <div className="luxury-pattern-line" style={{ top: '20%', left: '0', animationDelay: '0s' }}></div>
            <div className="luxury-pattern-line" style={{ top: '40%', left: '0', animationDelay: '2s' }}></div>
            <div className="luxury-pattern-line" style={{ top: '60%', left: '0', animationDelay: '4s' }}></div>
            <div className="luxury-pattern-line" style={{ top: '80%', left: '0', animationDelay: '6s' }}></div>

            {/* Luxury pattern dots */}
            <div className="luxury-pattern-dot" style={{ top: '30%', left: '20%' }}></div>
            <div className="luxury-pattern-dot" style={{ top: '50%', left: '40%' }}></div>
            <div className="luxury-pattern-dot" style={{ top: '70%', left: '60%' }}></div>
            <div className="luxury-pattern-dot" style={{ top: '40%', left: '80%' }}></div>
            <div className="luxury-pattern-dot" style={{ top: '60%', left: '30%' }}></div>

            <Container>
                <Row className="justify-content-center">
                    <Col md={6} lg={4}>
                        <Card className="shadow-lg border-0 luxury-glass-card">
                            <Card.Body className="p-4">
                                <div className="text-center mb-4">
                                    <h2 className="text-luxury-primary fw-bold mb-2"> SOHL CART</h2>
                                    <p className="text-luxury-muted mb-0"> Admin Dashboard</p>
                                    <small className="text-luxury-accent d-block mt-2">Exclusive Access</small>
                                </div>

                                {error && (
                                    <Alert variant="danger" className="mb-3">
                                        {error}
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="luxury-form-label">Email or Username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="username"
                                            value={formData.username}
                                            onChange={handleChange}
                                            placeholder="Enter your email or username"
                                            required
                                            disabled={loading}
                                            className="luxury-form-control"
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-4">
                                        <Form.Label className="luxury-form-label">Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            placeholder="Enter your password"
                                            required
                                            disabled={loading}
                                            className="luxury-form-control"
                                        />
                                    </Form.Group>

                                    <Button
                                        variant="primary"
                                        type="submit"
                                        className="w-100 py-3 fw-semibold luxury-btn"
                                        disabled={loading}
                                        size="lg"
                                    >
                                        {loading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="me-2"
                                                />
                                                Authenticating...
                                            </>
                                        ) : (
                                            'Access Dashboard'
                                        )}
                                    </Button>
                                </Form>

                                <div className="text-center mt-4 pt-3 border-top">
                                    <small className="text-luxury-muted">
                                        <span className="d-block mb-1">Demo Credentials:</span>
                                        <span className="d-block"><strong>Username/Email:</strong> king_superadmin@gmail.com</span>
                                        <span className="d-block"><strong>Password:</strong> 12345</span>
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Add the CSS styles inline or import them from your CSS file */}
            <style jsx>{`
                .luxury-login-bg {
                    background: linear-gradient(135deg, #3B0F0F 0%, #5A1F1F 25%, #7A1E1E 50%, #8A6A3F 75%, #C9A76A 100%) !important;
                    position: relative;
                    overflow: hidden;
                }
                
                .luxury-login-bg::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-image: 
                        radial-gradient(circle at 20% 30%, rgba(243, 233, 221, 0.1) 2px, transparent 2px),
                        radial-gradient(circle at 80% 70%, rgba(201, 167, 106, 0.1) 2px, transparent 2px),
                        radial-gradient(circle at 40% 80%, rgba(138, 106, 63, 0.1) 2px, transparent 2px),
                        radial-gradient(circle at 60% 20%, rgba(176, 140, 63, 0.1) 2px, transparent 2px);
                    background-size: 200px 200px;
                    opacity: 0.3;
                }
                
                .luxury-shape {
                    position: absolute;
                    font-size: 2.2rem;
                    opacity: 0.7;
                    animation: floatLuxury 25s infinite ease-in-out;
                    z-index: 0;
                    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.4));
                    text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
                }
                
                /* Specific luxury jewelry elements */
                .luxury-necklace {
                    color: #C9A76A;
                    font-size: 2.5rem;
                    animation: floatNecklace 20s infinite ease-in-out;
                }
                
                .luxury-earring {
                    color: #E0C690;
                    font-size: 2rem;
                    animation: floatEarring 18s infinite ease-in-out;
                }
                
                .luxury-ring {
                    color: #B08C3F;
                    font-size: 2.3rem;
                    animation: floatRing 22s infinite ease-in-out;
                }
                
                .luxury-bracelet {
                    color: #8A6A3F;
                    font-size: 2.4rem;
                    animation: floatBracelet 24s infinite ease-in-out;
                }
                
                .luxury-crown {
                    color: #FFD700;
                    font-size: 2.8rem;
                    animation: floatCrown 30s infinite ease-in-out;
                }
                
                .luxury-tiara {
                    color: #FFFFFF;
                    font-size: 2.6rem;
                    animation: floatTiara 26s infinite ease-in-out;
                }
                
                .luxury-diamond {
                    color: #FFFFFF;
                    font-size: 2.1rem;
                    animation: floatDiamond 19s infinite ease-in-out;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 50%;
                    width: 50px;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 0 25px rgba(255, 255, 255, 0.7);
                }
                
                .luxury-pearl {
                    color: #F3E9DD;
                    font-size: 2.2rem;
                    animation: floatPearl 21s infinite ease-in-out;
                    background: rgba(243, 233, 221, 0.1);
                    border-radius: 50%;
                    width: 45px;
                    height: 45px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 0 20px rgba(243, 233, 221, 0.6);
                }
                
                .luxury-gem {
                    color: #3B0F0F;
                    font-size: 2rem;
                    animation: floatGem 23s infinite ease-in-out;
                    background: rgba(59, 15, 15, 0.1);
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 0 15px rgba(59, 15, 15, 0.6);
                }
                
                .luxury-brooch {
                    color: #7A1E1E;
                    font-size: 2.4rem;
                    animation: floatBrooch 28s infinite ease-in-out;
                }
                
                .luxury-pendant {
                    color: #C9A76A;
                    font-size: 2.3rem;
                    animation: floatPendant 25s infinite ease-in-out;
                }
                
                /* Luxury patterns */
                .luxury-pattern-line {
                    position: absolute;
                    width: 100%;
                    height: 1px;
                    background: linear-gradient(90deg, transparent, rgba(243, 233, 221, 0.3), transparent);
                    animation: luxuryFlow 15s infinite linear;
                    box-shadow: 0 0 10px rgba(243, 233, 221, 0.3);
                }
                
                .luxury-pattern-dot {
                    position: absolute;
                    width: 6px;
                    height: 6px;
                    background: #C9A76A;
                    border-radius: 50%;
                    opacity: 0.5;
                    animation: luxuryFloat 20s infinite ease-in-out;
                    box-shadow: 0 0 8px #C9A76A;
                }
                
                /* Luxury glass card */
                .luxury-glass-card {
                    background: rgba(255, 255, 255, 0.95) !important;
                    backdrop-filter: blur(20px) !important;
                    border: 1px solid rgba(243, 233, 221, 0.4) !important;
                    border-radius: 20px !important;
                    z-index: 2;
                    position: relative;
                    box-shadow: 
                        0 25px 50px rgba(59, 15, 15, 0.3),
                        0 0 0 1px rgba(243, 233, 221, 0.1) inset !important;
                    overflow: hidden;
                }
                
                .luxury-glass-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(135deg, 
                        rgba(201, 167, 106, 0.05) 0%, 
                        rgba(243, 233, 221, 0.05) 25%, 
                        rgba(255, 255, 255, 0.05) 50%, 
                        rgba(176, 140, 63, 0.05) 75%, 
                        rgba(138, 106, 63, 0.05) 100%);
                    pointer-events: none;
                    z-index: -1;
                }
                
                /* Animations */
                @keyframes floatLuxury {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg) scale(1);
                    }
                    33% {
                        transform: translateY(-40px) rotate(120deg) scale(1.1);
                    }
                    66% {
                        transform: translateY(40px) rotate(240deg) scale(0.9);
                    }
                }
                
                @keyframes floatNecklace {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    25% {
                        transform: translateY(-50px) rotate(-10deg) scale(1.2);
                    }
                    50% {
                        transform: translateY(30px) rotate(10deg) scale(1);
                    }
                    75% {
                        transform: translateY(-30px) rotate(-5deg) scale(1.1);
                    }
                }
                
                @keyframes floatEarring {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-60px) rotate(180deg) scale(1.3);
                    }
                }
                
                @keyframes floatRing {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg) scale(1);
                    }
                    25% {
                        transform: translateY(-40px) rotate(90deg) scale(1.4);
                    }
                    50% {
                        transform: translateY(40px) rotate(180deg) scale(1);
                    }
                    75% {
                        transform: translateY(-20px) rotate(270deg) scale(1.2);
                    }
                }
                
                @keyframes floatBracelet {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(50px) rotate(360deg);
                    }
                }
                
                @keyframes floatCrown {
                    0%, 100% {
                        transform: scale(1) rotate(0deg);
                    }
                    25% {
                        transform: scale(1.4) rotate(15deg);
                    }
                    50% {
                        transform: scale(1.2) rotate(0deg);
                    }
                    75% {
                        transform: scale(1.3) rotate(-15deg);
                    }
                }
                
                @keyframes floatTiara {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-45px) rotate(10deg) scale(1.2);
                    }
                }
                
                @keyframes floatDiamond {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                        box-shadow: 0 0 25px rgba(255, 255, 255, 0.7);
                    }
                    50% {
                        transform: translateY(-35px) rotate(180deg);
                        box-shadow: 0 0 35px rgba(255, 255, 255, 1);
                    }
                }
                
                @keyframes floatPearl {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                        box-shadow: 0 0 20px rgba(243, 233, 221, 0.6);
                    }
                    50% {
                        transform: translateY(-40px) rotate(180deg);
                        box-shadow: 0 0 30px rgba(243, 233, 221, 0.9);
                    }
                }
                
                @keyframes floatGem {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                        box-shadow: 0 0 15px rgba(59, 15, 15, 0.6);
                    }
                    50% {
                        transform: translateY(-30px) rotate(180deg);
                        box-shadow: 0 0 25px rgba(59, 15, 15, 0.9);
                    }
                }
                
                @keyframes floatBrooch {
                    0%, 100% {
                        transform: translateY(0) scale(1);
                    }
                    50% {
                        transform: translateY(-25px) scale(1.3);
                    }
                }
                
                @keyframes floatPendant {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg);
                    }
                    50% {
                        transform: translateY(-55px) rotate(360deg);
                    }
                }
                
                @keyframes luxuryFlow {
                    0% {
                        transform: translateX(-100%);
                    }
                    100% {
                        transform: translateX(100%);
                    }
                }
                
                @keyframes luxuryFloat {
                    0%, 100% {
                        transform: translateY(0) scale(1);
                        opacity: 0.5;
                    }
                    50% {
                        transform: translateY(-25px) scale(1.3);
                        opacity: 0.8;
                    }
                }
                
                /* Responsive adjustments */
                @media (max-width: 768px) {
                    .luxury-shape {
                        font-size: 1.8rem;
                        opacity: 0.8;
                    }
                    
                    .luxury-diamond,
                    .luxury-pearl,
                    .luxury-gem {
                        width: 35px;
                        height: 35px;
                        font-size: 1.6rem;
                    }
                    
                    .luxury-glass-card {
                        border-radius: 15px !important;
                    }
                }
            `}</style>
        </Container>
    );
};

export default Login;